import type { DhLinkProps } from "@denhartog/ui";
import { Link } from "react-router-dom";

/** Adapter voor interne library-links: behoud React Router-navigatie. */
export function PortalLink({ href, ...props }: DhLinkProps) {
  return <Link to={href} {...props} />;
}
